import {Card as RTCard, CardTitle} from '@luminopia/react-toolbox/lib/card'
import FontIcon from '@luminopia/react-toolbox/lib/font_icon'
import * as classnames from 'classnames'
import * as React from 'react'
import * as styles from './styles.css'

interface IProps {
  className?: string
  title?: string
  subtitle?: string
  icon?: string
}

class Card extends React.PureComponent<IProps, {}> {
  public render() {
    const cardClassName = classnames(
      this.props.className,
      styles.card,
    )
    return (
      <RTCard className={cardClassName}>
        {this.props.title &&
          <CardTitle
            avatar={<FontIcon className={styles.icon} value={this.props.icon} />}
            title={this.props.title}
            subtitle={this.props.subtitle}
          />
        }
        {this.props.children}
      </RTCard>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/Card/index.tsx